var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccesslarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    viewBox: "0 0 217 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 216,
    height: 44,
    rx: 7.5,
    fill: "#212731",
    stroke: "url(#paint0_linear_621_521)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 36.4915C109.5 36.3113 109.597 36.1451 109.754 36.0563L119.849 30.3421C120.004 30.2541 120.195 30.2557 120.349 30.3462L124.454 32.761C124.785 32.9561 124.782 33.4371 124.447 33.6269L110.247 41.6767C109.913 41.8657 109.5 41.6249 109.5 41.2418V36.4915Z",
    fill: "url(#paint1_linear_621_521)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89 13.1576C89 12.7746 89.413 12.5338 89.7463 12.7225L94.0463 15.1564C94.2031 15.2452 94.3 15.4114 94.3 15.5916V27.6085C94.3 27.7887 94.2031 27.9549 94.0463 28.0437L89.7463 30.4776C89.413 30.6663 89 30.4255 89 30.0425V13.1576Z",
    fill: "url(#paint2_linear_621_521)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.754 7.04352C109.597 6.95484 109.5 6.78849 109.5 6.60816V1.85756C109.5 1.47456 109.913 1.23376 110.246 1.42243L124.646 9.5732C124.981 9.76284 124.985 10.2441 124.653 10.4393L120.548 12.8539C120.395 12.9443 120.204 12.946 120.049 12.8582L109.754 7.04352Z",
    fill: "url(#paint3_linear_621_521)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5654 10.3353C91.228 10.1435 91.2283 9.6571 91.5659 9.4657L105.753 1.42322C106.087 1.23427 106.5 1.47504 106.5 1.85819V6.60607C106.5 6.78751 106.402 6.95471 106.243 7.04295L96.1456 12.6632C95.993 12.7481 95.8071 12.7473 95.6553 12.661L91.5654 10.3353Z",
    fill: "url(#paint4_linear_621_521)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.948 27.8449C121.794 27.7552 121.7 27.5909 121.7 27.4133V15.8916C121.7 15.7115 121.797 15.5452 121.954 15.4565L126.254 13.0225C126.587 12.8339 127 13.0747 127 13.4577V29.9284C127 30.3146 126.581 30.555 126.248 30.36L121.948 27.8449Z",
    fill: "url(#paint5_linear_621_521)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6633 33.7307C91.326 33.5404 91.3237 33.0556 91.6591 32.8621L95.8521 30.443C96.0056 30.3544 96.1946 30.3537 96.3487 30.4412L106.247 36.0564C106.403 36.1452 106.5 36.3113 106.5 36.4913V41.2439C106.5 41.6266 106.088 41.8674 105.754 41.6794L91.6633 33.7307Z",
    fill: "url(#paint6_linear_621_521)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7998 27.3071L97.7998 15.8905L108 10.0755L118.2 15.8905V27.3071L108 33.0268L97.7998 27.3071Z",
    fill: "url(#paint7_linear_621_521)",
    stroke: "url(#paint8_linear_621_521)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_521",
    x1: 108.5,
    y1: 0,
    x2: 108.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57796B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57796B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_621_521",
    x1: 109.934,
    y1: 38.3168,
    x2: 121.92,
    y2: 31.2638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_621_521",
    x1: 91.2998,
    y1: 29.5715,
    x2: 98.3814,
    y2: 25.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375473,
    stopColor: "#90F243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54BD23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_621_521",
    x1: 123,
    y1: 11.5,
    x2: 109.794,
    y2: 4.38272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_621_521",
    x1: 107,
    y1: 3,
    x2: 93.2252,
    y2: 11.8506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_621_521",
    x1: 124,
    y1: 29.5001,
    x2: 131.01,
    y2: 25.5996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_621_521",
    x1: 104.145,
    y1: 40.625,
    x2: 91.175,
    y2: 33.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.432765,
    stopColor: "#90F243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54BD23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_621_521",
    x1: 97.892,
    y1: 25.9382,
    x2: 116.904,
    y2: 18.4084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_621_521",
    x1: 108,
    y1: 9.5,
    x2: 108,
    y2: 33.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesslarge);
export default __webpack_public_path__ + "static/media/successlarge.8c8f16f470b7ec844c72dde142e55c3e.svg";
export { ForwardRef as ReactComponent };